import { INotificationMessage } from "@fl/shared/src/types/messages";
import { IServiceDespesa, IServiceRoutes } from "@fl/shared/src/types/services";
import { ITableDataColumns } from "@fl/shared/src/types/tables";
import { useState } from "react";
import { IoReloadCircleOutline, IoReloadCircleSharp } from "react-icons/io5";
import ServiceDespesaModal from "../../../components/modals/servicesDespesa";
import TableData from "../../../components/tables";
import ApiServices from "../../../services/suporte/auth/services";
import DefaultBasePage from "../../default/base";

const ConfigUpdatersPrivatePage = () => {
  const columnsTable: ITableDataColumns[] = [
    {
      columnKey: "id_servico",
      label: "#ID",
      showColumn: false,
      pk: true,
      alignText: "text-center",
    },
    { columnKey: "nome", label: "Serviço", alignText: "text-start" },
    {
      columnKey: "{actions}",
      label: "Ação",
      action: true,
      alignText: "text-center",
      actionButtons: [
        {
          label: "",
          icon: <IoReloadCircleOutline size={22.5} />,
          iconHover: <IoReloadCircleSharp size={22.5} />,
          hover: false,
          action: (item) => onClick(item),
        },
      ],
    },
  ];

  const services: IServiceRoutes[] = [
    {
      id_servico: 1,
      nome: "Atualização de Condomínios",
      route: "condominios",
    },
    {
      id_servico: 2,
      nome: "Atualização de Fornecedores",
      route: "fornecedores",
    },
    {
      id_servico: 3,
      nome: "Atualização de Etiquetas",
      route: "etiquetas",
    },
    {
      id_servico: 4,
      nome: "Atualização de Impostos",
      route: "impostos",
    },
    {
      id_servico: 5,
      nome: "Atualização de Planos Contábeis",
      route: "planos-condominios",
    },
    {
      id_servico: 6,
      nome: "Atualização de Grupos de Condomínios",
      route: "grupos-condominios",
    },
    {
      id_servico: 7,
      nome: "Atualização de Despesas",
      route: "despesas",
    },
  ];

  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState<INotificationMessage[]>([]);
  const [showModalDespesas, setshowModalDespesas] = useState(false);
  const [selectedService, setSelectedService] = useState<IServiceRoutes | null>(
    null
  );

  const onClick = async (item: IServiceRoutes) => {
    if (item.id_servico === 7) {
      setSelectedService({ ...item });
      setshowModalDespesas(true);
    } else {
      onUpdate(item);
    }
  };

  const onResult = (data: any) => {
    if (data) {
      if (selectedService) {
        onUpdate(selectedService, data);
      }
    } else {
      setshowModalDespesas(false);
    }
  };

  const onUpdate = async (item: IServiceRoutes, data?: IServiceDespesa) => {
    try {
      setLoading(true);
      const result = await new ApiServices({
        ...data,
        route: item.route,
      }).updaters();

      if (result.message && result.message.length > 0)
        setMessages(result.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DefaultBasePage
      title="Atualizações - Superlógica"
      subtitle="Serviços de atualizações (espelhamento) entre Superlógica x Suporte FL"
      loading={loading}
      message={messages}
    >
      <div className="text-justify">
        <TableData columns={columnsTable} data={services} />

        <ServiceDespesaModal
          showModal={showModalDespesas}
          onResult={onResult}
        />
      </div>
    </DefaultBasePage>
  );
};

export default ConfigUpdatersPrivatePage;
